import Toast from '../constants/constants';

const {Html5QrcodeScanner} = require('html5-qrcode');

class Scanner
{
    init() {
        this.initScanner();
    }

    initScanner() {
        let scanType = $('#type');

        $(document).on('click', '#html5-qrcode-anchor-scan-type-change', function() {
            if(scanType.val() === 'camera'){
                scanType.val('file')
            } else {
                scanType.val('camera')
            }
        })

        function onScanSuccess(decodedText, decodedResult) {
            if (scanType.val() === 'camera'){
                scanner.pause();
            }
            backdrop.show('Verifying...')
            $.ajax({
                url: '/attendance/scan/verify',
                dataType: 'json',
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    id: decodedText,
                    conference: $('#attendance-conference').val(),
                    session: $('#attendance-session').val(),
                    section: $('#attendance-section').val(),
                    date: $('#attendance-date').val(),
                },
                success: function(response){
                    backdrop.hide();
                    Toast.fire({
                        icon: response.type,
                        title: response.title,
                        html: response.message
                    });
                    // Swal.fire(response.title, response.message, response.status);
                    setTimeout(function(){
                        if (scanType.val() === 'camera'){
                            scanner.resume();
                        }
                    }, 3000)
                },
                error: function(){
                    backdrop.hide();
                    Toast.fire({
                        icon: 'error',
                        title: 'An error occurred while verifying. Please try again or contact your System Administrator'
                    });
                    // Swal.fire('Error','An error occurred while verifying. Please try again or contact your System Administrator','error');
                    setTimeout(function(){
                        if (scanType.val() === 'camera'){
                            scanner.resume();
                        }
                    }, 3000)
                }
            })
        }

        function onScanFailure(error) {
            scanner.pause();
            stream.getTracks().forEach(function (track) {
                track.stop();
            });
        }

        if($('#reader').length < 1){
            return;
        }
        let scanner = new Html5QrcodeScanner(
            "reader",
            { fps: 23, qrbox: { width: 300, height: 300 } },
            /* verbose= */ false
        );

        scanner.render(onScanSuccess);

        $('.html5-qrcode-element').addClass('btn btn-sm bg-gradient-info');
        $('#html5-qrcode-button-camera-start').addClass('btn btn-sm bg-gradient-info mt-1')
        $('#html5-qrcode-button-camera-stop').removeClass('bg-gradient-info').addClass('btn btn-sm bg-gradient-danger mt-1')
        $('#html5-qrcode-anchor-scan-type-change').removeClass('bg-gradient-info').addClass('bg-gradient-dark text-decoration-none');
    }
}

export default Scanner.prototype
